import React, { Component } from 'react';
import { getQuestionsFromData } from './DownloadCSV';
import { Document, PDFDownloadLink, StyleSheet, View, Text, } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';
import { Button } from 'reactstrap';

const Body = styled.Page`
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 20px;
  padding-left: 20px;
`;

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingRight: '20px',
    paddingLeft: '20px',
  },
  title: {
    margin: '12px',
    fontSize: '18',
    fontFamily: 'Times-Roman',
    textDecoration: 'underline',
  },
  subtitle: {
    margin: '12px',
    fontSize: '14',
    fontFamily: 'Times-Roman',
    textDecoration: 'underline',
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  column: {
    flexDirection: 'column',
    flex: 1,
    flexWrap: 'wrap',
  },
  question: {
    margin: '12px',
    fontSize: '14',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  answer: {
    margin: '12px',
    fontSize: '14',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
});

const generateQuestions = (merged, allQuestions, data) => {
  const doc = [];
  doc[0] = (
    <View key="view">
      <Text key="title" style={styles.title}>
        Digital Triage Tool
      </Text>
    </View>
  );
  let currentGroup = null;
  for (const key in merged) {
    const groupId = key.slice(0, 1);
    if (groupId !== currentGroup) {
      doc.push(<View>
        <Text key={groupId} style={styles.subtitle}>
          {data.item.find(item => item.linkId === groupId).text}
        </Text>
      </View>);
      currentGroup = groupId;
    }


    doc.push(<View style={styles.row}>
      <View style={styles.column}>
        <Text style={styles.question}>
          {`${allQuestions.find(item => item.id === key).question}: `}
        </Text>
      </View>
      <View wrap style={styles.column}>
        {merged[key].map(answer => (
          <Text key={answer} style={styles.answer}>
            {answer}
          </Text>
        ))}
      </View>
    </View>);
  }
  return doc;
};

class DownloadPDF extends Component {
  state = {
    merged: null,
    allQuestions: null,
    myDocument: null,
  };
  componentWillMount() {
    const allQuestions = getQuestionsFromData(this.props.data);
    const answers = this.props.answers;

    const merged = {};
    allQuestions.forEach((element) => {
      answers.forEach((answer) => {
        if (element.id === answer.id) {
          merged[element.id] = answer.answers;
        }
      });
    });
    this.setState({ merged, allQuestions });
  }
  render() {
    const { merged, allQuestions } = this.state;
    const { data } = this.props;
    const myDocument = (
      <Document>
        <Body wrap size="A4">
          {generateQuestions(merged, allQuestions, data)}
        </Body>
      </Document>
    );

    return (
      <PDFDownloadLink
        document={myDocument}
        fileName={merged.A1 ? `${merged.A1}-DTT.pdf` : 'blank.pdf'}
      >
        <Button
          color="success"
          disabled={!merged.A1}
          className="question-button"
        >
          Download Answers as PDF
        </Button>
      </PDFDownloadLink>
    );
  }
}

export default DownloadPDF;



// WEBPACK FOOTER //
// ./src/components/DownloadPDF.js